/**
 * @generated SignedSource<<dba898ba2e368931d1ae8bde65807462>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type QueueActionsBuildsQuery$variables = {
  locator: string;
};
export type QueueActionsBuildsQuery$data = {
  readonly queuedBuilds: {
    readonly " $fragmentSpreads": FragmentRefs<"QueueActionsFragment">;
  } | null | undefined;
};
export type QueueActionsBuildsQuery = {
  response: QueueActionsBuildsQuery$data;
  variables: QueueActionsBuildsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "locator"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "locator",
    "variableName": "locator"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "QueueActionsBuildsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Builds",
        "kind": "LinkedField",
        "name": "queuedBuilds",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "QueueActionsFragment"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "QueueActionsBuildsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Builds",
        "kind": "LinkedField",
        "name": "queuedBuilds",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Build",
            "kind": "LinkedField",
            "name": "build",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "_id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "f8ec85ebcbd0e6d28a28e74c5b304c74",
    "id": null,
    "metadata": {},
    "name": "QueueActionsBuildsQuery",
    "operationKind": "query",
    "text": "query QueueActionsBuildsQuery(\n  $locator: String!\n) {\n  queuedBuilds(locator: $locator) {\n    ...QueueActionsFragment\n  }\n}\n\nfragment QueueActionsFragment on Builds {\n  build {\n    id\n    _id\n  }\n}\n"
  }
};
})();

(node as any).hash = "605184a5a5a0d82e9e7aac8cf111437a";

export default node;
